<style scoped>
ion-avatar {
  /*max-width: 1000px !important;
  max-height: 100px !important;*/
  width: 60px;
  height: 60px;
}

#wrapper {
  height: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#image {
  z-index: -100;
  min-height: 100%;
  min-width: 100%;
}
</style>

<template>
  <base-layout page-default-back-link="/HomePageAttivita">
    <ion-header>
      <ion-toolbar>
        <ion-row>
          <ion-col size="10" class="ion-text-center" style="font-weight: bold">{{ pSearch }}</ion-col>
          <ion-col size="1"> <ion-icon :icon="apps" @click="ViewList = false"></ion-icon></ion-col>
          <ion-col size="1"> <ion-icon :icon="list" @click="ViewList = true"></ion-icon> </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-header>
    <ion-list v-if="ViewList">
      <ion-item v-for="item in arcAttivita" :key="item.Att_desc">
        <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
          <ion-avatar>
            <img v-bind:src="$SITE_URL + item.Att_imgc" alt="" />
          </ion-avatar>
        </router-link>
        <div style="padding-left: 23px" class="item-icon-right">
          <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
            <div class="item-text-wrap">
              <h2 style="font-size: 17px !important; margin: 0px; margin-top: 3px; margin-bottom: 2px">{{ item.Att_desc }}</h2>
              <p style="font-size=14px !important; margin:0px; margin-bottom: 2px;">
                {{ item.Att_cat1 }} <span v-if="item.Att_cat1 != item.Att_cat2">- {{ item.Att_cat2 }}</span>
              </p>
            </div></router-link
          >
          <ion-chip
            v-for="item2 in JSON.parse(item.Tags)"
            :key="item2"
            outline
            color="primary"
            :router-link="{ name: 'AttivitaLista', params: { pSearch: item2.t } }"
            ><ion-label v-html="item2.t"></ion-label
          ></ion-chip>
        </div>
      </ion-item>
    </ion-list>

    <ion-row v-if="!ViewList">
      <ion-col v-for="item in arcAttivita" :key="item.Att_desc" size="12" size-xs="12" size-lg="4" size-md="4" size-sm="4">
        <ion-card>
          <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
            <div class="item item-body">
              <div
                v-bind:style="{
                  'background-image': 'url(' + $SITE_URL + item.Att_imgc + ')',
                  height: '90vh',
                  'max-height': '200px',
                  'background-size': 'cover',
                }"
              ></div>
            </div>
            <ion-card-header>
              <ion-card-subtitle>{{ item.Att_cat1 + "-" + item.Att_cat2 }}</ion-card-subtitle>
              <ion-card-title v-html="item.Att_desc"></ion-card-title>
            </ion-card-header>
          </router-link>
          <ion-card-content>
            <ion-chip
              v-for="item2 in JSON.parse(item.Tags)"
              :key="item2"
              outline
              color="primary"
              :router-link="{ name: 'AttivitaLista', params: { pSearch: item2.t } }"
              ><ion-label v-html="item2.t"></ion-label
            ></ion-chip>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row style="background-color: #4d4b4b; height: 50px; color: #e4e4e4">
      <ion-col size="12" style="margin: 10px">
        <b>{{ $t("Attività correlate") }}</b>
      </ion-col>
    </ion-row>

    <ion-list v-if="ViewList">
      <ion-item v-for="item in arcCorrelate" :key="item.Att_desc">
        <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
          <ion-avatar>
            <img v-bind:src="$SITE_URL + item.Att_imgc" alt="" />
          </ion-avatar>
        </router-link>
        <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
          <div style="padding-left: 23px" class="item-icon-right">
            <div class="item-text-wrap">
              <h2 style="font-size: 17px !important; margin: 0px; margin-top: 3px; margin-bottom: 2px">{{ item.Att_desc }}</h2>
              <p style="font-size=14px !important; margin:0px; margin-bottom: 2px;">
                {{ item.Att_cat1 }} <span v-if="item.Att_cat1 != item.Att_cat2">- {{ item.Att_cat2 }}</span>
              </p>
            </div>
            <ion-chip
              v-for="item2 in JSON.parse(item.Tags)"
              :key="item2"
              outline
              color="primary"
              :router-link="{ name: 'AttivitaLista', params: { pSearch: item2.t } }"
              ><ion-label v-html="item2.t"></ion-label
            ></ion-chip>
          </div>
        </router-link>
      </ion-item>
    </ion-list>

    <ion-row v-if="!ViewList">
      <ion-col v-for="item in arcCorrelate" :key="item.Att_desc" size="12" size-xs="12" size-lg="4" size-md="4" size-sm="4">
        <ion-card>
          <router-link style="text-decoration: none; color: inherit" :to="{ name: 'AttivitaDet', params: { pAtt_Codi: item.Att_codi } }">
            <div class="item item-body">
              <div
                v-bind:style="{
                  'background-image': 'url(' + $SITE_URL + item.Att_imgc + ')',
                  height: '90vh',
                  'max-height': '200px',
                  'background-size': 'cover',
                }"
              ></div>
            </div>
            <ion-card-header>
              <ion-card-subtitle>{{ item.Att_cat1 + "-" + item.Att_cat2 }}</ion-card-subtitle>
              <ion-card-title v-html="item.Att_desc"></ion-card-title>
            </ion-card-header>
          </router-link>
          <ion-card-content>
            <ion-chip
              v-for="item2 in JSON.parse(item.Tags)"
              :key="item2"
              outline
              color="primary"
              :router-link="{ name: 'AttivitaLista', params: { pSearch: item2.t } }"
              ><ion-label v-html="item2.t"></ion-label
            ></ion-chip>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </base-layout>
</template>

<script>
import {
  BaseLayout,
  IonToolbar,
  IonRow,
  IonCol,
  IonIcon,
  IonList,
  IonItem,
  IonAvatar,
  IonHeader,
  IonCard,
  IonChip,
  IonLabel,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from "@ionic/vue";
import { apps, list } from "ionicons/icons";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";

export default {
  name: "AttivitaLista",
  components: {
    BaseLayout,
    IonToolbar,
    IonRow,
    IonCol,
    IonIcon,
    IonList,
    IonItem,
    IonAvatar,
    IonHeader,
    IonCard,
    IonChip,
    IonLabel,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
  },
  data() {
    return {
      arcAttivita: [],
      arcCorrelate: [],
      pSearch: "",
      apps,
      list,
      ViewList: true,
    };
  },
  methods: {
    GetPulsanti() {
      const self = this;
      let prm = [];
      // inline
      prm.push(new CommandParam("@Search", "", DbParamType.AnsiString, 50, ParameterDirection.Input, this.pSearch));
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Tabella_AttivitaRicreative02_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.arcAttivita = data.RecordSet.Table;
            self.arcCorrelate = data.RecordSet.Table1;
          } else {
            self.arcAttivita = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.pSearch = this.$route.params.pSearch;
    this.GetPulsanti();
  },
};
</script>
